import StandardLayout from '@/common/layouts/StandardLayout';
import { InputGroup, InputGroupText } from 'reactstrap';
import { ReactComponent as CalendarIcon } from '@/assets/icons/calendar.svg';
import TournamentOverviewStats from './components/TournamentOverviewStats';
import { useMemo, useState } from 'react';
import { sub, subDays, subHours, subMinutes, subYears } from 'date-fns';

const SngOverviewPage = () => {
  const [fromDate, setFromDate] = useState<string | null>('year-10');

  const fromDateValue = useMemo(() => {
    if (!fromDate) {
      return null;
    }

    const timeIncrement = fromDate?.split('-')?.[0];
    const timeAmount = fromDate?.split('-')?.[1];

    if (timeIncrement === 'min') {
      return subMinutes(new Date(), parseInt(timeAmount));
    } else if (timeIncrement === 'hour') {
      return subHours(new Date(), parseInt(timeAmount));
    } else if (timeIncrement === 'day') {
      return subDays(new Date(), parseInt(timeAmount));
    } else if (timeIncrement === 'year') {
      return subYears(new Date(), parseInt(timeAmount));
    }

    return null;
  }, [fromDate]);

  return (
    <StandardLayout
      pageTitle="Sit & Go Overview"
      headerButton={
        <div className="d-flex align-items-center justify-content-between">
          <InputGroup>
            <InputGroupText>
              <CalendarIcon />
            </InputGroupText>
            <select className="form-select" value={fromDate ?? '-'} onChange={(e) => setFromDate(e.target.value)}>
              <option value="-">-</option>
              <option value="min-5">Last 5 minutes</option>
              <option value="min-10">Last 10 minutes</option>
              <option value="min-30">Last 30 minutes</option>
              <option value="hour-1">Last 1 hour</option>
              <option value="hour-2">Last 2 hours</option>
              <option value="hour-4">Last 4 hours</option>
              <option value="hour-8">Last 8 hours</option>
              <option value="hour-12">Last 12 hours</option>
              <option value="hour-24">Last 24 hours</option>
              <option value="hour-48">Last 48 hours</option>
              <option value="day-7">Last week</option>
              <option value="day-30">Last 30 days</option>
              <option value="year-10">All</option>
            </select>
          </InputGroup>
        </div>
      }
    >
      <TournamentOverviewStats fromDate={fromDateValue} toDate={new Date()} />
    </StandardLayout>
  );
};

export default SngOverviewPage;
